// extracted by mini-css-extract-plugin
module.exports = {"container":"promoFooter__container___3xtOp"};